import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileIconService {

//   | Icon Type      | Description / Examples                            |
// | -------------- | ------------------------------------------------- |
// | **pdf**        | PDF files                                         |
// | **word**       | DOC, DOCX                                         |
// | **excel**      | XLS, XLSX, CSV                                    |
// | **powerpoint** | PPT, PPTX                                         |
// | **text**       | TXT, MD, RTF, LOG                                 |
// | **image**      | JPG, PNG, GIF, SVG, BMP, WEBP, ICO                |
// | **zip**        | ZIP, RAR, 7z, TAR, GZ                             |
// | **audio**      | MP3, WAV, FLAC, OGG                               |
// | **video**      | MP4, MOV, AVI, MKV, WEBM                          |
// | **code**       | JS, TS, HTML, CSS, PHP, JAVA, PY, JSON, XML, etc. |
// | **font**       | TTF, OTF, WOFF, WOFF2                             |
// | **default**    | For unknown or unhandled file types               |


  private extensionMap:any = {
    // Documents
    pdf: {
      type:'pdf',
      image:'pdf.svg'
    },
    doc: {
      type:'word',
      image:'word.svg'
    },
    docx: {
      type:'word',
      image:'word.svg'
    },
    xls: {
      type:'excel',
      image:'excel.svg'
    },
    xlsx: {
      type:'excel',
      image:'excel.svg'
    },
    csv: {
      type:'excel',
      image:'excel.svg'
    },
    ppt: {
      type:'powerpoint',
      image:'ppt.svg'
    },
    pptx: {
      type:'powerpoint',
      image:'ppt.svg'
    },
    txt: {
      type:'text',
      image:'text.svg'
    },
    md: {
      type:'text',
      image:'text.svg'
    },
    rtf: {
      type:'text',
      image:'text.svg'
    },
    log: {
      type:'text',
      image:'text.svg'
    },

    // Images
    jpg: {
      type:'image',
      image:'image.svg'
    },
    jpeg: {
      type:'image',
      image:'image.svg'
    },
    png: {
      type:'image',
      image:'image.svg'
    },
    gif: {
      type:'image',
      image:'image.svg'
    },
    bmp: {
      type:'image',
      image:'image.svg'
    },
    svg: {
      type:'image',
      image:'image.svg'
    },
    webp: {
      type:'image',
      image:'image.svg'
    },
    ico: {
      type:'image',
      image:'image.svg'
    },

    // Archives
    zip: {
      type:'zip',
      image:'zip.svg'
    },
    rar: {
      type:'zip',
      image:'zip.svg'
    },
    tar: {
      type:'zip',
      image:'zip.svg'
    },
    gz: {
      type:'zip',
      image:'zip.svg'
    },
    '7z': {
      type:'zip',
      image:'zip.svg'
    },

    // Audio
    mp3: {
      type:'audio',
      image:'audio.svg'
    },
    wav: {
      type:'audio',
      image:'audio.svg'
    },
    flac: {
      type:'audio',
      image:'audio.svg'
    },
    ogg: {
      type:'audio',
      image:'audio.svg'
    },

    // Video
    mp4: {
      type:'video',
      image:'video.svg'
    },
    mov: {
      type:'video',
      image:'video.svg'
    },
    avi: {
      type:'video',
      image:'video.svg'
    },
    mkv: {
      type:'video',
      image:'video.svg'
    },
    webm: {
      type:'video',
      image:'video.svg'
    },

    // Code / Config
    html: {
      type:'code',
      image:'code.svg'
    },
    htm: {
      type:'code',
      image:'code.svg'
    },
    css: {
      type:'code',
      image:'code.svg'
    },
    scss: {
      type:'code',
      image:'code.svg'
    },
    js: {
      type:'code',
      image:'code.svg'
    },
    jsx: {
      type:'code',
      image:'code.svg'
    },
    ts: {
      type:'code',
      image:'code.svg'
    },
    tsx: {
      type:'code',
      image:'code.svg'
    },
    json: {
      type:'code',
      image:'code.svg'
    },
    xml: {
      type:'code',
      image:'code.svg'
    },
    yml: {
      type:'code',
      image:'code.svg'
    },
    yaml: {
      type:'code',
      image:'code.svg'
    },
    php: {
      type:'code',
      image:'code.svg'
    },
    py: {
      type:'code',
      image:'code.svg'
    },
    java: {
      type:'code',
      image:'code.svg'
    },
    c: {
      type:'code',
      image:'code.svg'
    },
    cpp: {
      type:'code',
      image:'code.svg'
    },
    h: {
      type:'code',
      image:'code.svg'
    },
    cs: {
      type:'code',
      image:'code.svg'
    },
    sh: {
      type:'code',
      image:'code.svg'
    },
    bash: {
      type:'code',
      image:'code.svg'
    },
    ini: {
      type:'code',
      image:'code.svg'
    },
    env: {
      type:'code',
      image:'code.svg'
    },
    sql: {
      type:'code',
      image:'code.svg'
    },

    // Fonts
    ttf: {
      type:'font',
      image:'font.svg'
    },
    otf: {
      type:'font',
      image:'font.svg'
    },
    woff: {
      type:'font',
      image:'font.svg'
    },
    woff2: {
      type:'font',
      image:'font.svg'
    }
  };

  constructor() { }

  getFileTypeIcon(fileName: string): string {
    const iconPath = environment.image_path+'file-icons/'
    const ext = fileName?.split('.').pop()?.toLowerCase();
    const mapped = ext ? this.extensionMap[ext] : null;
    return iconPath + (mapped?.image || 'default-file.svg');
  }
}
